import CarrierApi from "../../services/api/Carriers";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in carriers actions :", err);
}

export const setCarriersList = (payload) => {
  return {
    type: ActionTypes.SET_CARRIERS_LIST,
    payload,
  };
};

export const setCarrierModels = (payload) => {
  return {
    type: ActionTypes.SET_CARRIER_MODELS,
    payload,
  };
};

export const getCarriersList = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await CarrierApi.getCarriersList();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setCarriersList(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getCarrierModels = (carrierId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await CarrierApi.getCarrierModels(carrierId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setCarrierModels(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
